import { CSSProperties, FC, ReactElement } from 'react';

import { Picture, Wrapper } from '../../../components';
import { LinkIconButton, SectionFooter } from '../../../compositions';
import { ConnectedProductCard } from '../../../connectors';
import { ProductCollectionInterface } from '../../../entities/@blocks/ProductCollection/ProductCollection';
import { Product } from '../../../entities/@products/Product/Product';
import { HorizontalAlignment } from '../../../entities/Alignment/Alignment';

import './ProductCollection.scss';

export interface ProductCollectionProps extends ProductCollectionInterface {
    products: Product[];
    className?: string;
}

export const ProductCollection: FC<ProductCollectionProps> = ({
    title,
    titleColor,
    media,
    products,
    link,
    className = '',
}): ReactElement => {
    const cssVariables = {
        '--c-product-collection-title': titleColor,
    } as CSSProperties;

    return (
        <section style={cssVariables} className={`product-collection ${className}`}>
            <Wrapper>
                <header className="product-collection__header">
                    <h2 className="product-collection__header-title">
                        {title}
                    </h2>

                    <div className="product-collection__header-divider" />
                </header>

                <div className="product-collection__items">
                    {media.map(item => {
                        const buttonsCssVariables = {
                            '--c-production-collection-button-text': item.textColor,
                            '--c-production-collection-button-background': item.backgroundColor,
                        } as CSSProperties;

                        return (
                            <div
                                key={item.id}
                                style={buttonsCssVariables}
                                className="product-collection__item"
                            >
                                <Picture
                                    {...item.image}
                                    className="product-collection__item-picture"
                                    imageClassName="product-collection__item-image"
                                />

                                {item.link && (
                                    <LinkIconButton
                                        style={buttonsCssVariables}
                                        hasAnimation
                                        iconPos={HorizontalAlignment.right}
                                        icon="arrow-right"
                                        to={item.link.href}
                                        text={item.link.label}
                                        className="product-collection__item-link"
                                    />
                                )}
                            </div>
                        );
                    })}
                </div>

                <div className="product-collection__product-list">
                    {products.map(product => (
                        <ConnectedProductCard
                            key={product.id}
                            product={product}
                            className="product-collection__product-item"
                            pictureClassName="product-collection__product-item-picture"
                        />
                    ))}
                </div>

                {link && (
                    <SectionFooter
                        link={link}
                        className="product-collection__footer"
                    />
                )}
            </Wrapper>
        </section>
    );
};
